<template>
    <div class="max-w-7xl mx-auto px-6 lg:px-8">
        <PageTitle v-bind:title="title" v-bind:admin="false" />



      <div class="">
        <div class="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
          <p
            class="text-center text-sm font-semibold uppercase text-gray-500 tracking-wide"
          >
            <!-- Trusted by -->
          </p>
          <div class="mt-6 grid grid-cols-1 gap-8 md:grid-cols-2">
            <div
              class="col-span-1 flex justify-center md:col-span-2 md:col-start-2 lg:col-span-1"
            >
                <a href="https://xn--80afcdbalict6afooklqi5o.xn--p1ai/"><img class="h-32" src="/images/LOGO_FOND_01.png" alt="" /></a>
            </div>
            <!--
            <div
              class="col-span-2 flex justify-center md:col-span-2 md:col-start-4 lg:col-span-1"
            >
              <img class="h-10 pt-1" src="/images/fdm-logo-full.png" alt="" />
            </div>
            -->
          </div>
        </div>
      </div>


    </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";
export default {
    data() {
        return {
            title: 'Партнёры'
        }
    },
    components: {
        PageTitle,
    }
}
</script>